import { FC, useMemo } from 'react'
import { CheckOutlined, CloseOutlined } from '@ant-design/icons'
import { Typography, Space, Card } from 'antd'
import {
  cardBodyStyle,
  cardStyle,
  cardWithBackgroundStyle,
  Container,
  ContainerHeader,
  iconCheckStyle,
  iconCloseStyle,
  titleStyle
} from './PasswordStrength.styles'
import { useTranslation } from 'react-i18next'
import { PasswordValidationConfig } from '../ChangePasswordInputs/ChangePasswordInputs.types'
import { useChangePasswordValidations } from '../../../hooks/useChangePasswordValidations'

interface PasswordStrengthProps {
  password: string
  validationConfig: PasswordValidationConfig
  showDetailedView?: boolean
}

const PasswordStrength: FC<PasswordStrengthProps> = ({ password, showDetailedView = false, validationConfig }) => {
  const { t } = useTranslation()
  const { getAllPasswordRules } = useChangePasswordValidations(validationConfig)
  const rules = useMemo(() => {
    return getAllPasswordRules(password)
  }, [password, getAllPasswordRules])

  return (
    <Card style={showDetailedView ? cardWithBackgroundStyle : cardStyle} bodyStyle={cardBodyStyle}>
      <ContainerHeader showDetailedView={showDetailedView}>
        <Typography.Title level={5} style={titleStyle}>
          {t('password_strength.password_must_contain')}:
        </Typography.Title>
      </ContainerHeader>
      <Space direction='vertical' style={{ width: '100%' }}>
        {rules.map((rule) => (
          <Container key={rule.label}>
            {rule.isValid ? (
              <CheckOutlined style={iconCheckStyle} />
            ) : (
              <CloseOutlined style={{ ...iconCloseStyle, color: `${showDetailedView ? '#f5222d' : '#00000073'}` }} />
            )}
            <Typography.Text
              type={rule.isValid ? 'success' : `${showDetailedView ? 'danger' : 'secondary'}`}
              style={{ transition: 'color 0.3s ease-in-out' }}
            >
              {rule.label}
            </Typography.Text>
          </Container>
        ))}
      </Space>
    </Card>
  )
}

export default PasswordStrength
